import { Tool, ToolType } from './Tool'
import { Select } from 'ol/interaction'

export default class SelectTool extends Tool {
    private selectInteraction!: Select;

    public removeInteractions(): void {
        if (this.selectInteraction) { this.state.map?.removeInteraction(this.selectInteraction) }
    }

    public addInteractions(): void {
        this.selectInteraction = new Select({
            multi: false,
            layers: [this.state.vectorLayer!],
            filter: (feature, layer) => feature.get('type') !== ToolType.MEASURING
        })

        this.state.map!.addInteraction(this.selectInteraction)

        this.selectInteraction.on('select', async (evt) => {
            const feature = evt.selected[0]
            await this.annotationManager.applyAnnotationDetails(feature, true)
            this.state.vectorSource?.dispatchEvent('change')
            this.selectInteraction.getFeatures().clear()
        })
    }
}
